{
  "list": {
    "title": "Templates",
    "add": "Add Template",
    "filters": {
      "status": "Status",
      "language": "Language"
    },
    "columns": {
      "key": "Template Key",
      "language": "Language",
      "metaName": "Meta Template Name",
      "variables": "Variables",
      "description": "Description",
      "status": "Status"
    },
    "rowActions": {
      "trigger": "Actions for {{name}}"
    }
  },
  "drawer": {
    "createTitle": "Add Template",
    "editTitle": "Edit Template",
    "createDescription": "Register an approved Meta template for the message log to use.",
    "editDescription": "Update this template's Meta details and description.",
    "fields": {
      "key": "Template Key",
      "language": "Language",
      "metaName": "Meta Template Name",
      "metaLanguage": "Meta Language Code",
      "variables": "Variables",
      "variablesHelp": "This order fills the approved template's numbered placeholders, first to last.",
      "addVariable": "Add Variable",
      "variablePlaceholder": "Variable name",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "removeVariable": "Remove variable",
      "bodyText": "Message Text",
      "headerType": "Header",
      "headerTypeHelp": "Choose Image when the approved Meta template has an image header, such as a QR code.",
      "headerTypeNone": "None",
      "headerTypeImage": "Image",
      "descriptionAr": "Arabic Description",
      "descriptionEn": "English Description",
      "verificationCode": "Verification code template",
      "verificationCodeHelp": "A Meta authentication template with a copy-code button. Its only variable is code, and this option cannot change after creation."
    },
    "created": "Template created successfully",
    "updated": "Template updated successfully"
  },
  "statusConfirmTitle": "Change this template's status?",
  "statusConfirmDescription": "\"{{name}}\" will become {{status}}.",
  "statusChanged": "Template status changed successfully"
}
